import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import { ko } from 'date-fns/locale';
import styles from './Join.module.scss';
import common from '../../common';
import axios from 'axios';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Join() {
    const { useAlert,useConfirm,useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pConfirm, ConfirmComponent } = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();

    const [selectedDate, setSelectedDate] = useState('');
    const [forumDate, setForumDate] = useState('');

    const [career_pack, setCareer_pack] = useState([{ idx: '1', career: '' }]);
    const [education, setEducation] = useState([{ idx: '1', university: '', major: '',degree: '', degreeAttend: '' }]);

    const [terms, setTerms] = useState({
        allChecked: false,
        termsOfService: false,
        privacyPolicy: false,
    });

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        password_confirm: '',
        name: '',
        phone: '',
        forum_idx: '0',
        keyword: '',
        job: '',
        future: '',
        address: '',
        addressDetail: '',
        forumList : [],
    });

    useEffect(() => {
        const fetchData = async () => {
            pLoadingOn();

            const fetchUrl = API_BASE_URL+'/yehs_forum/out/get_forum_table';
            const fetchOptions = {withCredentials: true};

            try {
                const response = await axios.post(fetchUrl, { }, fetchOptions);
                if (response.data.result === 't') {
                    setFormData(prevState => ({
                        ...prevState,
                        forumList : response.data.data,
                    }));
                } else {
                    pAlert('데이터 불러오기가 실패했습니다. 관리자에게 문의해주세요.');
                }
            } catch (error) {
                pAlert('데이터 불러오기가 실패했습니다. 관리자에게 문의해주세요.');
            }
            pLoadingOff();
        };
    
        fetchData();
    }, []);

    const handleAllCheckedChange = () => {
        const newCheckedState = !terms.allChecked;
        setTerms({
            allChecked: newCheckedState,
            termsOfService: newCheckedState,
            privacyPolicy: newCheckedState,
        });
    };

    const handleCheckboxChange = (name) => {
        setTerms((prevTerms) => {
            const newTerms = {
                ...prevTerms,
                [name]: !prevTerms[name],
            };
            return {
                ...newTerms,
                allChecked: newTerms.termsOfService && newTerms.privacyPolicy,
            };
        });
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (`0${date.getMonth() + 1}`).slice(-2);
        const day = (`0${date.getDate()}`).slice(-2);
        return `${year}-${month}-${day}`;
    };

    const handleCareerChange = (idx, value) => {
        setCareer_pack(career_pack.map(career => career.idx === idx ? { ...career, career: value } : career));
    };

    const handleAddCareer = () => {
        setCareer_pack([...career_pack, { idx: (career_pack.length + 1).toString(), career: '' }]);
    };

    const handleRemoveCareer = (idx) => {
        setCareer_pack(career_pack.filter(career => career.idx !== idx));
    };

    const handleEducationChange = (idx, field, value) => {
        setEducation(education.map(edu => edu.idx === idx ? { ...edu, [field]: value } : edu));
    };

    const handleAddEducation = () => {
        setEducation([...education, { idx: (education.length + 1).toString(), university: '', major: '', degree:'', degreeAttend:'' }]);
    };

    const handleRemoveEducation = (idx) => {
        setEducation(education.filter(edu => edu.idx !== idx));
    };









    // 휴대폰 형식
    const formatPhoneNumber = (input) => {
        input = input.replace(/\D/g, ''); // 숫자만 남기기

        if (input.length > 3 && input.length <= 7) {
            return `${input.slice(0, 3)}-${input.slice(3)}`;
        } else if (input.length > 7) {
            return `${input.slice(0, 3)}-${input.slice(3, 7)}-${input.slice(7, 11)}`;
        }
        return input;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;

        if (name === 'phone') {
            formattedValue = formatPhoneNumber(value); // 전화번호 형식화
        }

        setFormData(prevState => ({
            ...prevState,
            [name]: formattedValue,
        }));
    };











    const handleClick = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                setFormData({
                    ...formData,
                    address: data.address,
                });
            },
        }).open();
    };




    const handleSubmit = async() => {
        const {
            email, password, password_confirm, name,
            phone, forum_idx, keyword, job, future
        } = formData;

        

        // 1. 비밀번호와 비밀번호 확인 값이 다를 때
        if (password !== password_confirm) {
            pAlert('비밀번호가 맞지 않습니다. 다시 확인해주세요.');
            return;
        }

        
        // 2. 필수값이 없는 경우
        const requiredFields = {
            email: "이메일",
            password: "비밀번호",
            password_confirm: "비밀번호 확인",
            name: "이름",
            selectedDate: "생년월일",
            phone: "핸드폰 번호",
            address: "주소",
            addressDetail: "상세주소",
            forum_idx: "참여포럼 및 입회시기",
            future: "진로",
        };

        const formDataWithDate = { ...formData, selectedDate };

        
        const emptyFields = Object.entries(requiredFields).filter(([key, value]) => !formDataWithDate[key]);
        if (emptyFields.length > 0) {
            pAlert(`필수 입력값 (${emptyFields.map(([, value]) => value).join(', ')}) 이(가) 없습니다`);
            return;
        }

        // 2.3 education 유효성 검사
        if (education.length === 0 || education.some(edu => !edu.university.trim() || !edu.major.trim() || !edu.degree || !edu.degreeAttend)) {
            pAlert('출신학교 및 전공 정보를 입력해 주세요.');
            return;
        }



        // 3. 이용약관 동의가 안 되어 있는 경우
        if (!terms.termsOfService || !terms.privacyPolicy) {
            pAlert('이용약관 및 개인정보 수집 및 이용동의에 동의해 주세요');
            return;
        }

        const careerArray = career_pack.map(career => career.career);

        const sendData = {
            ...formData,
            birth: selectedDate,
            // forumDate,
            career_pack : careerArray,
            university_pack : education,
        };

        // 4. 콘솔에 출력


        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_login/out/regist_member`, sendData, {
                withCredentials: true
            });
    
            if (response.data.result === 't') {
                const data = response.data.data;
                pAlert('회원가입이 완료되었습니다.');
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };


    const [isPasswordEnabled, setIsPasswordEnabled] = useState(false); // 비밀번호 필드 활성화 상태

    const handleEmailCheck = async() => {
        
        
        // 4. 콘솔에 출력

        const email = formData.email;

        if(email === ''){
            pAlert('이메일을 입력해주세요.');
            return false;
        }

        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_login/out/yehs_login_email_chk`, { email : email }, {
                withCredentials: true
            });
    
            if (response.data.result === 't') {
                pAlert(response.data.msg + ' 입니다.');
                setIsPasswordEnabled(true); // 비밀번호 필드 활성화
            } else {
                pAlert(response.data.msg);
                setIsPasswordEnabled(false); // 비밀번호 필드 비활성화
            }
        } catch (error) {
            pAlert('실패함.');
            setIsPasswordEnabled(false); // 비밀번호 필드 비활성화
        } finally {
            pLoadingOff();
        }
    };

    return (
        <>
        <AlertComponent />
        <LoadingComponent />
        <ConfirmComponent />
        <div className={styles.components_wrap}>
            <div className={styles.join_title}>회원가입</div>
            <div className={styles.join_form_wrap}>
                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>이메일</span>
                        <span className={styles.required}>*</span>
                    </div>
                    <div className="flex_between">
                        <input
                            type="text"
                            className={`${styles.join_input} ${styles.join_p_input}`}
                            placeholder="이메일"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        <button className={styles.duplicate_check_button} onClick={handleEmailCheck}>중복확인</button>
                    </div>
                    <p className={styles.error_message}>이메일을 입력해주세요.</p>
                </div>

                <form>
                    <div className={styles.join_form_group}>
                        <div className={`${styles.join_form_box} display_flex`}>
                            <span>비밀번호</span>
                            <span className={styles.required}>*</span>
                        </div>
                        <input
                            type="password"
                            className={`${styles.join_input} ${styles.join_p_input}`}
                            placeholder="비밀번호"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            autoComplete="off"
                            disabled={!isPasswordEnabled} // 비활성화 상태 반영
                        />
                    </div>

                    <div className={styles.join_form_group}>
                        <div className={`${styles.join_form_box} display_flex`}>
                            <span>비밀번호 확인</span>
                            <span className={styles.required}>*</span>
                        </div>
                        <input
                            type="password"
                            className={`${styles.join_input} ${styles.join_p_input}`}
                            placeholder="비밀번호 확인"
                            name="password_confirm"
                            value={formData.password_confirm}
                            onChange={handleInputChange}
                            autoComplete="off"
                            disabled={!isPasswordEnabled} // 비활성화 상태 반영
                        />
                    </div>
                </form>
                                

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>이름</span>
                        <span className={styles.required}>*</span>
                    </div>
                    <input
                        type="text"
                        className={`${styles.join_input} ${styles.join_p_input}`}
                        placeholder="이름"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                    />
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>생년월일</span>
                        <span className={styles.required}>*</span>
                    </div>
                    <div className={styles.date_picker_wrapper}>
                        <DatePicker
                            selected={selectedDate}
                            dateFormat="yyyy-MM-dd"
                            className={styles.date_picker}
                            placeholderText="생년월일"
                            locale={ko}
                            onChange={(date) => {
                                const changeDate = formatDate(date);
                                setSelectedDate(changeDate);
                            }}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                        <FaCalendarAlt className={styles.calendar_icon} />
                    </div>
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>핸드폰 번호</span>
                        <span className={styles.required}>*</span>
                    </div>
                    <input
                        type="text"
                        className={`${styles.join_input} ${styles.join_p_input}`}
                        placeholder="핸드폰 번호를 적어주세요."
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                    />
                </div>


                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box}  display_flex`}>
                        <span>주소</span>
                        <span className={styles.required}>*</span>
                        <button
                            className={styles.address_btn}
                            onClick={handleClick}
                            >
                            주소 검색
                        </button>
                    </div>
                    
                    <input
                        type="text"
                        className={`${styles.join_input} ${styles.join_p_input}`}
                        placeholder="주소"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                    />
                    <input
                        type="text"
                        className={`${styles.join_input} ${styles.join_p_input}`}
                        placeholder="상세주소"
                        name="addressDetail"
                        value={formData.addressDetail}
                        onChange={handleInputChange}
                    />
                </div>



                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box}`}>
                        <span>참여포럼 및 입회시기</span>
                        <span className={styles.required}>*</span>
                    </div>
                    <div className="flex_between">
                        <select
                            className={styles.join_select}
                            name="forum_idx"
                            value={formData.forum_idx}
                            onChange={handleInputChange}
                        >
                            <option value="0">참여포럼 없음</option>
                            {formData.forumList.map((forum, index) => (
                                <option key={index} value={forum.idx}>
                                    {forum.time}회 / [{forum.year}년 {forum.month}월]
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>키워드</span>
                    </div>
                    <input
                        type="text"
                        className={`${styles.join_input} ${styles.join_p_input}`}
                        placeholder="키워드(,로 구분)"
                        name="keyword"
                        value={formData.keyword}
                        onChange={handleInputChange}
                    />
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>직장</span>
                    </div>
                    <input
                        type="text"
                        className={`${styles.join_input} ${styles.join_p_input}`}
                        placeholder="직장"
                        name="job"
                        value={formData.job}
                        onChange={handleInputChange}
                    />
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} ${styles.display_flex} `}>
                        <span>경력</span>
                    </div>
                    {career_pack.map((career, index) => (
                        <div className={`${styles.flex_between} ${styles.m_b_10}`} key={career.idx}>
                            <input
                                type="text"
                                className={`${styles.join_botton_input} ${styles.join_p_input}`}
                                placeholder="경력"
                                value={career.career}
                                onChange={(e) => handleCareerChange(career.idx, e.target.value)}
                            />
                            {index === 0 ? (
                                <button className={`${styles.add_btn} ${styles.a_r_btn}`} onClick={handleAddCareer}>+</button>
                            ) : (
                                <button className={`${styles.remove_btn} ${styles.a_r_btn}`} onClick={() => handleRemoveCareer(career.idx)}>-</button>
                            )}
                        </div>
                    ))}
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>진로</span>
                        <span className={styles.required}>*</span>
                    </div>
                    <select
                        className={styles.join_select}
                        name="future"
                        value={formData.future}
                        onChange={handleInputChange}
                    >
                        <option value="0">선택하세요.</option>
                        <option value="1">대학생</option>
                        <option value="2">대학원생</option>
                        <option value="3">취업(직장생활)</option>
                    </select>
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>출신학교 및 전공</span>
                        <span className={styles.required}>*</span>
                    </div>
                    {education.map((edu, index) => (
                        <div className={`${styles.flex_between} ${styles.m_b_10}`} key={edu.idx}>
                            <input
                                type="text"
                                className={`${styles.join_botton_input_2} ${styles.join_p_input}`}
                                placeholder="학교"
                                value={edu.university}
                                onChange={(e) => handleEducationChange(edu.idx, 'university', e.target.value)}
                            />
                            <input
                                type="text"
                                className={`${styles.join_botton_input_2} ${styles.join_p_input}`}
                                placeholder="전공"
                                value={edu.major}
                                onChange={(e) => handleEducationChange(edu.idx, 'major', e.target.value)}
                            />
                            <select
                                className={`${styles.join_botton_input_2} ${styles.join_p_input}`}
                                value={edu.degree} // 학위에 대한 값
                                onChange={(e) => handleEducationChange(edu.idx, 'degree', parseInt(e.target.value, 10))} // 학위를 int로 변환하여 저장
                            >
                                <option value="0">선택하세요.</option>
                                <option value="1">학사</option>
                                <option value="2">석사</option>
                                <option value="3">박사</option>
                            </select>
                            <select
                                className={`${styles.join_botton_input_2} ${styles.join_p_input}`}
                                value={edu.degreeAttend} // 학위 상태에 대한 값
                                onChange={(e) => handleEducationChange(edu.idx, 'degreeAttend', parseInt(e.target.value, 10))} // 학위 상태를 변경
                            >
                                <option value="0">선택하세요.</option>
                                <option value="1">재학</option>
                                <option value="2">수료</option>
                                <option value="3">졸업</option>
                            </select>
                            {index === 0 ? (
                                <button className={`${styles.add_btn} ${styles.a_r_btn}`} onClick={handleAddEducation}>+</button>
                            ) : (
                                <button className={`${styles.remove_btn} ${styles.a_r_btn}`} onClick={() => handleRemoveEducation(edu.idx)}>-</button>
                            )}
                        </div>
                    ))}
                </div>

                <div className={styles.join_form_group}>
                    <div className={`${styles.join_form_box} display_flex`}>
                        <span>이용약관</span>
                        <span className={styles.required}>*</span>
                    </div>
                    <div className={styles.terms_box}>
                    <label className="p_chkbox">
                        <input
                            type="checkbox"
                            checked={terms.allChecked}
                            onChange={handleAllCheckedChange}
                        />
                        <span>전체동의</span>
                    </label>
                    <hr className={styles.terms_divider} />
                    <label className="p_chkbox">
                        <input
                            type="checkbox"
                            checked={terms.termsOfService}
                            onChange={() => handleCheckboxChange('termsOfService')}
                        />
                        <span>이용약관<span className={styles.required}>(필수)</span></span>
                    </label>
                    <label className="p_chkbox">
                        <input
                            type="checkbox"
                            checked={terms.privacyPolicy}
                            onChange={() => handleCheckboxChange('privacyPolicy')}
                        />
                        <span>개인정보 수집 및 이용동의<span className={styles.required}>(필수)</span></span>
                    </label>
                </div>
                <p className={styles.error_message}>*는 필수 입력사항입니다.</p>
                </div>

                <button className={styles.user_insert_btn} onClick={() => pConfirm('회원가입','회원가입을 하시겠습니까?','350px','auto',handleSubmit,'확인','취소')}>회원가입</button>
            </div>
        </div>
        </>
        
    );
}

export default Join;
